<template>
  <strong v-if="!causer">System</strong>
  <strong v-else-if="causer.id == $authUser.id">You</strong>
  <strong v-else>{{ causer.name }}</strong>
</template>

<script>
export default {
  name: 'LatestUpdatesCauser',
  props: {
    causer: {
      type: Object,
      nullable: true
    }
  }
}
</script>
